import React from 'react';

import Dropdown from 'ui-library/dropdowns/Dropdown';
import {OverflowButton} from 'ui-library/menus/OverflowMenu';

interface Props {
  className?: string;
  menu: JSX.Element;
}

/**
 * Button that opens an overflow dropdown menu on click
 */
export default function BaseBlockOverflowDropdown(props: Props): JSX.Element {
  return (
    <Dropdown menu={props.menu}>
      <OverflowButton
        className={props.className}
        dataTestAttrs={{
          component: 'BaseBlockOverflowDropdown',
          element: 'button',
        }}
        enableTooltip={true}
      />
    </Dropdown>
  );
}
